import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style/style.css";
import { icons } from "../../constants";

import { useLanguage } from "../../utils/useLanguage";
import { resolveLocale, getMonthNames, getWeekdayShort } from "./locale-utils";

export default function CustomDateRangePicker({
  mode = "range",
  dateRange,
  setDateRange,
  label,
  required,
  className,
  error,
  disabled,
}) {
  const { language } = useLanguage("en"); // 👈 OVDE
  const localeCode = resolveLocale(language);

  const months = React.useMemo(() => getMonthNames(localeCode), [localeCode]);

  const [startDate, endDate] =
    mode === "range" ? (dateRange ?? [null, null]) : [null, null];
  const selected =
    mode === "single" && dateRange ? new Date(dateRange) : null;

  return (
    <div
      className={`flex-direction-column items-center gap-8 width-100 height-100 custom-date-range-picker dropdown ${
        disabled ? "disabled" : ""
      }`}
    >
      {label && (
        <div
          className={`flex-direction-row items-center width-100 relative ${
            disabled ? "disabled" : ""
          }`}
        >
          {required && (
            <img
              src={icons.required}
              alt="req"
              width={12}
              height={12}
              style={{ position: "absolute", top: 0, left: 0 }}
            />
          )}
          <label className="font-12 inria-sans-700">{label}</label>
        </div>
      )}

      <div
        className={`flex-direction-row items-center width-100 justify-between date-time-picker-input-wrapper relative ${
          error ? "error" : ""
        } ${disabled ? "disabled" : ""}`}
      >
        <DatePicker
          {...(mode === "range"
            ? {
                selectsRange: true,
                startDate,
                endDate,
                onChange: (upd) => setDateRange?.(upd),
              }
            : {
                selected,
                onChange: (d) => setDateRange?.(d),
              })}
          /* ⬇⬇⬇ LOKALIZACIJA */
          dateFormat="dd.MM.yyyy"
          calendarStartDay={1}
          renderCustomHeader={({ date, changeMonth, changeYear }) => (
            <div className="custom-datepicker-header">
              <select
                value={date.getMonth()}
                onChange={(e) => changeMonth(Number(e.target.value))}
              >
                {months.map((m, i) => (
                  <option key={i} value={i}>
                    {m}
                  </option>
                ))}
              </select>

              <select
                value={date.getFullYear()}
                onChange={(e) => changeYear(Number(e.target.value))}
              >
                {Array.from({ length: 50 }, (_, i) => {
                  const y = new Date().getFullYear() - 25 + i;
                  return (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
          formatWeekDay={(name, date) => getWeekdayShort(localeCode, date)}
          /* ⬆⬆⬆ */

          isClearable
          shouldCloseOnSelect={mode === "range" ? false : undefined}
          disabled={disabled}
        />

        <img
          src={icons.calendar}
          alt="cal"
          width={24}
          height={24}
          className={`date-range-picker-icon ${disabled ? "disabled" : ""}`}
          style={{
            position: "absolute",
            right: "8px",
            cursor: disabled ? "not-allowed" : "pointer",
            pointerEvents: "none",
          }}
        />
      </div>
    </div>
  );
}
